import * as React from 'react'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import cn from 'classnames'
import FillButton from 'components/presenter/buttons/FillButton'
import WebpImage from 'components/presenter/image/WebpImage'
import * as styles from './styles.module.css'

const iconMap = {
  'Banner': '/images/paid_service_banner.png',
  'FeatureList': '/images/paid_service_feature.png',
}

const PromotionSolutionSection = () => {
  const { t } = useTranslation()
  const stepItem = (type) => (
      <div className={styles.stepRoot}>
        <WebpImage className={cn(styles.stepIcon)} src={iconMap[type]} alt='' />
        <p className={styles.stepTitle}>{t(`landing.paidService${type}`)}</p>
      </div>
    )
  return (
    <>
      <div className={cn(styles.sectionRoot, 'container')}>
        <h3>
          {t('landing.paidService')}
        </h3>
        <div className={styles.contentRoot}>
          {stepItem('Banner')}
          {stepItem('FeatureList')}
        </div>
        <FillButton
          className={cn(styles.btnDesign, 'mui-btn-link')}>
          <a
            href = "mailto:kingwu@creatisoft.io"
          >
            {t('common.contactUs')}
          </a>
        </FillButton>
      </div>
    </>
  )
}

export default PromotionSolutionSection